<div class="display-flex margin-top-1">
    <app-team-header [teamMember]="teamMember"
                     size="small"
                     font="body"
                     [showBackButton]="false"></app-team-header>
</div>
